import { getDocs, doc, collection, query, setDoc } from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "trending", id);
};

export const getTrendingArticles = async () => {
  const q = query(collection(db, "trending"));
  const querySnapshot = await getDocs(q);
  const articles = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return articles;
};

export const updateTrendingArticles = async (id, data) => {
  try {
    await setDoc(getDocument(id), data, { marge: true });
  } catch (e) {
    console.error(`Error while updating trending articles ${e}`);
    return false;
  }
};
